export const environment = {
    production: true,
    WIDGET_API_URI: '##{WIDGET_API_URI}##'
};